export default "__VITE_ASSET__CRRkpmkp__"